import React, {useContext, useState, useEffect, Fragment} from "react";
import {buyNowContext} from "../BuyNow";
import {PORTALS} from "../../../../constants";

function ChooseModeStage() {
  const {
    PURCHASE_STAGES, setPurchaseStage, appInfo, CLINICIAN_MODES, setClinicianMode, portal
  } = useContext(buyNowContext);

  const businessName = appInfo.name;

  return (
    <div style={{display: "flex", flexDirection: "column", alignItems: "center", gap: "25px", padding: "10px"}}>
      <div style={{textAlign: "center"}}>
        <h2 id="buy-now-header" className="col-lg-12 text-lg-center d-lg-block mt-4">
          {`${businessName} Clinician`}
        </h2>
      </div>

      <div style={{textAlign: "center"}}>
        Welcome to MyClearStep! Please select an option to proceed.
      </div>

      <Option title="New Organization" onClick={() => {
        setClinicianMode(CLINICIAN_MODES.NEW_ORGANIZATION);
        setPurchaseStage(PURCHASE_STAGES.PRODUCT_SELECTION);
      }}>
        I'm a new clinician that needs to purchase admin portal access and create an organization.
      </Option>

      <Option title="Existing Organization" onClick={() => {
        setClinicianMode(CLINICIAN_MODES.EXISTING_ORGANIZATION);
        setPurchaseStage(PURCHASE_STAGES.PRODUCT_SELECTION);
      }}>
        I'm an existing clinician with an organization that needs to purchase additional admin access seats or other
        products.
      </Option>

      <Option title="Join Organization" onClick={() => {
        if (portal === PORTALS.CLEARSTEP)
          window.location = "/organizations/join-mcs";
        else
          window.location = "/organizations/join";
      }}>
        I need to join an existing organization.
      </Option>
    </div>
  );
}

function Option({ title, onClick = () => {}, children }) {
  return (
    <div className="rounded-sm shadow" style={{width: "100%", maxWidth: "500px", border: "1px solid lightgray", padding: "25px", borderRadius: "10px"}}>
      <div style={{fontWeight: "bold"}}>{title}</div>
      {children}

      <br/>
      <br/>

      <div style={{ textAlign: "right" }}>
        <a
          className="teal button-link next-button-txt next-step-button shipping-info-btn"
          onClick={onClick}
        >
          Next
        </a>
      </div>
    </div>
  );
}

export default ChooseModeStage;